import { Link } from "react-router-dom";
import { LogoWordmark } from "./Logo";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[#E3E0D8] bg-[#F1EEE8] overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-8">
      <div className="flex flex-col lg:flex-row lg:items-start justify-between gap-12">
        <div className="max-w-sm">
          <LogoWordmark />
          <p className="mt-7 text-sm font-light leading-relaxed text-[#6E6A61]">
            An independent strategic advisory firm serving private families, institutional investors and
            asset managers across complex transactions, private capital and alternative assets.
          </p>
        </div>
        <div className="flex flex-wrap gap-16 lg:gap-20">
          <div>
            <p className="font-serif text-xs uppercase tracking-[0.3em] text-[#1F1E1B]/70">Expertise</p>
            <ul className="mt-6 space-y-3">
              {[
                ["Strategic Advisory & M&A", "/strategic-advisory"],
                ["Private Capital", "/private-capital"],
                ["Family Office Advisory", "/family-office-advisory"],
                ["Sports Investments", "/sports-investments"],
              ].map(([label, href]) => (
                <li key={label}>
                  <Link to={href} className="group relative text-sm text-[#1F1E1B]/75 hover:text-[#1F1E1B] transition-colors duration-300">
                    {label}
                    <span className="absolute -bottom-0.5 left-0 h-px w-0 bg-[#1F1E1B] transition-[width] duration-300 group-hover:w-full" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-serif text-xs uppercase tracking-[0.3em] text-[#1F1E1B]/70">Firm</p>
            <ul className="mt-6 space-y-3">
              {[
                ["About PJG", "/about"],
                ["Sectors", "/sectors"],
                ["Insights", "/insights"],
                ["Contact", "/contact"],
              ].map(([label, href]) => (
                <li key={label}>
                  <Link to={href} className="group relative text-sm text-[#1F1E1B]/75 hover:text-[#1F1E1B] transition-colors duration-300">
                    {label}
                    <span className="absolute -bottom-0.5 left-0 h-px w-0 bg-[#1F1E1B] transition-[width] duration-300 group-hover:w-full" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-serif text-xs uppercase tracking-[0.3em] text-[#1F1E1B]/70">Contact</p>
            <ul className="mt-6 space-y-3 text-sm text-[#1F1E1B]/75">
              <li>
                <a href="mailto:enquiries@pjgcp.com" className="hover:text-[#1F1E1B] transition-colors duration-300">
                  enquiries@pjgcp.com
                </a>
              </li>
              <li>Mayfair, London</li>
              <li>United Kingdom</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-[#D8D4CB]">
        <p className="font-sans text-[10px] uppercase tracking-[0.24em] text-[#1F1E1B]/60 mb-3">
          Regulatory & Legal Disclosures
        </p>
        <p className="text-xs leading-relaxed text-[#6E6A61] max-w-4xl">
          [Placeholder — to be completed upon confirmation of the firm's regulatory arrangements.] The
          contents of this website are provided for general information only. PJG Capital Partners does not
          provide, and does not claim to provide, regulated investment advice, investment management,
          securities distribution or capital raising services unless and until the necessary regulatory
          arrangements are confirmed. Nothing on this website constitutes investment advice, an offer, or a
          solicitation. Advisory mandates are distinct from transactions in which the firm may invest as
          principal; any potential conflict of interest is disclosed and addressed with relevant parties.
        </p>
        <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="font-sans text-[10px] uppercase tracking-[0.24em] text-[#6E6A61]">
            © 2026 PJG Capital Partners · www.pjgcp.com
          </p>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="font-sans text-[10px] uppercase tracking-[0.24em] text-[#6E6A61]/80 hover:text-[#1F1E1B] transition-colors duration-300"
          >
            Partner Access
          </Link>
        </div>
      </div>
    </div>

    <div className="relative select-none pointer-events-none" aria-hidden="true">
      <p className="font-serif font-light text-[13vw] leading-[0.85] tracking-tighter text-center whitespace-nowrap text-[#1F1E1B]/[0.05] -mb-[2vw]">
        PJG CAPITAL
      </p>
    </div>
  </footer>
);
